<div class="cw-root">

  <!-- Identity -->
  <div class="cw-identity">
    <span class="cw-phase">{{ phaseLabel }}</span>
    <h2 class="cw-name">{{ callerName }}</h2>
    <p class="cw-sub">{{ subLabel }}</p>
  </div>

  <!-- Stage 320x320 -->
  <div class="cw-stage">

    <!-- Active outer ring -->
    <div class="cw-outer-ring" [class.visible]="phase === 'active'"></div>

    <!-- Purple pulse ring -->
    <div class="cw-pulse cw-pulse--purple" [class.paused]="!pulseActive"></div>
    <!-- Green pulse ring offset 1.1s -->
    <div class="cw-pulse cw-pulse--green" [class.paused]="!pulseActive"></div>

    <!-- INCOMING BUTTONS -->
    <ng-container *ngFor="let btn of incomingBtns; trackBy: trackById">
      <div
        class="cw-arc-wrap"
        [style.opacity]="incomingOpen ? 1 : 0"
        [style.pointer-events]="incomingOpen ? 'auto' : 'none'"
        [style.transform]="btnTransform(btn, incomingOpen)"
        [style.transition]="btnTransition(btn.delay)"
      >
        <button
          class="cw-abtn"
          [style.background]="btn.bg"
          [class.pulse-red]="btn.pulseClass === 'pulse-red'"
          [class.pulse-green]="btn.pulseClass === 'pulse-green'"
          [class.pulse-blue]="btn.pulseClass === 'pulse-blue'"
          (click)="handleIncoming(btn.id)"
        >
          <span class="material-symbols-outlined" [style.color]="btn.color">{{ btn.icon }}</span>
        </button>
        <span class="cw-alabel" [style.color]="btn.color">{{ btn.label }}</span>
      </div>
    </ng-container>

    <!-- ACTIVE CONTROL BUTTONS -->
    <ng-container *ngFor="let btn of activeBtns; trackBy: trackById">
      <div
        class="cw-arc-wrap"
        [style.opacity]="activeOpen ? 1 : 0"
        [style.pointer-events]="activeOpen ? 'auto' : 'none'"
        [style.transform]="btnTransform(btn, activeOpen)"
        [style.transition]="btnTransition(btn.delay)"
      >
        <button
          class="cw-abtn"
          [style.background]="getControlBg(btn)"
          (click)="handleActive(btn.id)"
        >
          <span class="material-symbols-outlined" [style.color]="getControlColor(btn)">
            {{ getControlIcon(btn) }}
          </span>
        </button>
        <span class="cw-alabel" [style.color]="getControlColor(btn)">
          {{ getControlLabel(btn) }}
        </span>
      </div>
    </ng-container>

    <!-- End call — anchored bottom center, visible during active -->
    <div class="cw-end" [class.visible]="showEnd">
      <button class="cw-abtn cw-abtn--end pulse-red" (click)="onEnd()">
        <span class="material-symbols-outlined" style="color:#ffb4ab;">call_end</span>
      </button>
      <span class="cw-alabel" style="color:#ffb4ab;">End Call</span>
    </div>

    <!-- Main bubble -->
    <div
      class="cw-bubble"
      [class.cw-bubble--clickable]="phase === 'incoming' || phase === 'active'"
      [class.cw-bubble--declined]="phase === 'declined'"
      [style.box-shadow]="bubbleGlow"
      [style.transform]="bubbleTransform"
      (click)="onBubbleTap()"
    >
      <img [src]="callerImg" [alt]="callerName" class="cw-img" />

      <!-- EQ bars -->
      <div class="cw-eq">
        <div
          *ngFor="let bar of eqBars"
          class="cw-bar"
          [style.height.px]="bar.height"
          [style.animation]="eqAnimation(bar.delay)"
        ></div>
      </div>
    </div>

  </div><!-- /stage -->

  <!-- Status pill -->
  <div class="cw-pill">
    <div class="cw-dot" [class.cw-dot--teal]="phase === 'hold'"></div>
    <span class="cw-stxt">{{ statusText }}</span>
  </div>

  <!-- Auto-dismiss progress bar -->
  <div class="cw-progress" [class.visible]="menuOpen">
    <div
      class="cw-progress-fill"
      [class.running]="menuOpen"
      [style.transition-duration]="progressDuration"
    ></div>
  </div>

  <!-- Tap hint -->
  <p *ngIf="showHint" class="cw-hint" [class.hidden]="menuOpen">
    {{ hintText }}
  </p>

</div>
